import { Plugin } from 'vue'
import Pusher from 'pusher-js'
import config from '@/config'

/* The API issues the auth header value per user; whos-viewing-indicator sets it before subscribing */
export const pusherAuthHeaders: Record<string, string> = {}

declare module 'vue' {
  interface ComponentCustomProperties {
    $pusher: Pusher
  }
}

export default {
  install(app) {
    app.config.globalProperties.$pusher = new Pusher(config.pusherApiKey, {
      cluster: 'mt1',
      channelAuthorization: {
        endpoint: `${config.apiUrl}pusher-auth/channel-auth`,
        transport: 'ajax',
        headersProvider: () => pusherAuthHeaders,
      },
    })
  },
} as Plugin
